import gql from 'graphql-tag'
// import slugify from 'slugify'

export const GetControlByReferenceID = () => {
  return gql`query CCC {
        controlByReferenceID(referenceID: "A4"){
          controlID
          description
          referenceID
          advice
          assetType
          securityFunction
          helpText
          hasSolution
          solutionTags
        }
      }`
}

//framework: String
export const GetPlaybook = () => {
  return gql`query playbook($playbookData: CompliancePlaybookInput){
        compliancePlaybook(input: $playbookData){
            framework
            playbook
            updatedAt
        }
    }`
}

//UpdateCompliancePlaybookInput
//framework, playbook
export const UpdatePlaybook = () => {
  return gql`mutation updatePlaybook($playbookData: UpdateCompliancePlaybookInput) {
      updateCompliancePlaybook(input: $playbookData){
        playbook
      }
    }`
}


// WEBPACK FOOTER //
// ./src/queries/playbook.js